import React, { Component } from 'react'
import './styles.css'
import Stars from '../Stars'
import Row from '../GridGM'
import Col from '../GridGM/Col'
import { getItemImage, getLocalizedString, getRating, getRelatedValue } from '../../../http/driveApiGateway/helper'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { constants } from '../../../constants'

class MainHotel extends Component {

  render () {
    const imageUrl = this.props.propertyImage ?? getItemImage(this.props.item, this.props.relatedItems, '320')
    return (
      <React.Fragment>
        <div className="Hotel Hotel-Large Hotel-Distribution Gradient clearfix">
          <Row grid="8">
            <Col cols="3">
              <Row>
                <Col cols="9">
                  <span className="Hotel-Image"
                        style={
                          { backgroundImage: 'url(' + imageUrl + ')' }
                        }></span>
                  <span className="Hotel-Inner">
                                            <h4>{getLocalizedString(this.props.item, 'name')}</h4>
                                            <p>{getRelatedValue(this.props.item, this.props.relatedItems, 'city')} | {
                                              getRelatedValue(this.props.item, this.props.relatedItems, 'country')}</p>
                                        </span>
                </Col>
                <Col cols="3">
                  <Stars count={getRating(this.props.item)} type={'white'}></Stars>
                </Col>
              </Row>
            </Col>
            <Col cols="1">
              <p>GIATA ID: {this.props.item.attr[constants.attributePaths.giataId][1].data.code}</p>
            </Col>
            <Col cols="4">
              {this.props.children}
            </Col>
          </Row>
        </div>
        <div className="Hotel Hotel-Large-Placeholder"></div>
      </React.Fragment>
    )
  }
}

MainHotel.propTypes = {
  item: PropTypes.object.isRequired,
  relatedItems: PropTypes.array.isRequired,
  propertyImage: PropTypes.string,
}

export default withTranslation()(MainHotel)
